import React, { useState } from 'react';
import { FiChevronDown, FiChevronUp, FiMail } from 'react-icons/fi';
import styles from '../AnnouncementsV2.module.css';

const InProgressEmailCard = ({ progressData }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  if (!progressData) return null;

  const {
    status,
    subject,
    total,
    processed,
    sent,
    failed,
    current_email,
    instructor_email,
    progress_percent
  } = progressData;

  const pending = total - processed;

  return (
    <div className={`${styles.emailCard} ${styles.inProgressCard}`}>
      <div className={styles.emailCardHeader}>
        <div className={styles.emailCardIcon}>
          <FiMail size={20} />
        </div>
        <div className={styles.emailCardInfo}>
          <span className={styles.emailCardTitle}>Announcement Email</span>
          <span className={styles.emailCardSender}>
            Sent by: {instructor_email || 'Instructor'}
          </span>
          <span className={styles.emailCardSubject}>
            Subject: {subject || 'Announcement'}
          </span>
        </div>
        <div className={styles.emailCardStatus}>
          <span className={`${styles.statusBadge} ${styles.statusInProgress}`}>
            ⏳ In Progress
          </span>
          <button
            className={styles.expandButton}
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? 'Hide Status' : 'View Status'}
            {isExpanded ? <FiChevronUp /> : <FiChevronDown />}
          </button>
        </div>
      </div>

      {isExpanded && (
        <div className={styles.progressSection}>
          {/* Progress Bar */}
          <div className={styles.progressBarWrapper}>
            <div
              className={styles.progressBar}
              style={{ width: `${progress_percent || 0}%` }}
            />
          </div>
          <div className={styles.progressPercent}>
            {progress_percent || 0}%
          </div>

          {/* Current Status */}
          <div className={styles.progressStatus}>
            <span className={styles.progressMessage}>
              {status === 'PENDING'
                ? 'Preparing to send...'
                : `Sending to student ${processed + 1} of ${total}...`}
            </span>
            {current_email && (
              <span className={styles.currentEmail}>
                Currently processing: {current_email}
              </span>
            )}
          </div>

          {/* Stats Grid */}
          <div className={styles.statsGrid}>
            <div className={styles.statBox}>
              <span className={styles.statLabel}>SENT</span>
              <span className={`${styles.statValue} ${styles.statSuccess}`}>{sent}</span>
            </div>
            <div className={styles.statBox}>
              <span className={styles.statLabel}>FAILED</span>
              <span className={`${styles.statValue} ${styles.statError}`}>{failed}</span>
            </div>
            <div className={styles.statBox}>
              <span className={styles.statLabel}>PENDING</span>
              <span className={styles.statValue}>{pending}</span>
            </div>
          </div>

          {/* Info Note */}
          <div className={styles.infoNote}>
            ℹ️ You can navigate away. Emails will continue sending in the background.
          </div>
        </div>
      )}
    </div>
  );
};

export default InProgressEmailCard;
